(function () {
  'use strict';

  // PDP-Below-Fold: wandelt den vertikalen Akkordeon-Stapel auf Desktop
  // (>=750px) in eine horizontale Tab-Leiste um (Progressive Enhancement).
  // Unter 750px sowie komplett ohne JS bleiben die nativen <details>-Akkordeons
  // unverändert erhalten — Markup wird nicht umgeschrieben, nur angereichert.

  var DESKTOP_MQ = '(min-width: 750px)';

  function init() {
    var root = document.querySelector('[data-pdp-content]');
    if (!root) return;
    var list = root.querySelector('.t-pdp-content__sections');
    if (!list) return;

    // Nur die OBERSTEN Akkordeons (direkte Kinder) werden zu Tabs. Die
    // Unter-Akkordeons im Legal-Panel (.t-acc--sub) liegen tiefer im Body und
    // bleiben bewusst Akkordeons innerhalb ihres Panels.
    var panels = [];
    for (var i = 0; i < list.children.length; i++) {
      var el = list.children[i];
      if (el.tagName === 'DETAILS' && el.classList.contains('t-acc')) panels.push(el);
    }
    if (panels.length < 2) return; // Tabs lohnen sich erst ab 2 Panels.

    // Default-Index = das initial offene Akkordeon (Beschreibung). Damit stellen
    // wir beim Zurückwechseln auf Mobile den Ausgangszustand wieder her.
    var defaultIndex = 0;
    for (var d = 0; d < panels.length; d++) {
      if (panels[d].hasAttribute('open')) { defaultIndex = d; break; }
    }

    var tablist = buildTablist(panels);
    list.insertBefore(tablist, panels[0]);
    var tabs = tablist.querySelectorAll('.t-pdp-tabs__tab');

    // URL-Anker berücksichtigen (z. B. #bewertungen öffnet direkt dieses Panel).
    var initialIndex = defaultIndex;
    var hashMatched = false;
    if (window.location.hash) {
      var hashId = window.location.hash.slice(1);
      for (var hx = 0; hx < panels.length; hx++) {
        if (panels[hx].id === hashId) { initialIndex = hx; hashMatched = true; break; }
      }
    }

    var activeIndex = initialIndex;

    function activate(index, focusTab) {
      activeIndex = index;
      for (var t = 0; t < tabs.length; t++) {
        var selected = t === index;
        tabs[t].setAttribute('aria-selected', selected ? 'true' : 'false');
        tabs[t].setAttribute('tabindex', selected ? '0' : '-1');
        panels[t].classList.toggle('is-active', selected);
        if (selected && focusTab) tabs[t].focus();
      }
    }

    // Klick.
    tablist.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.t-pdp-tabs__tab') : null;
      if (!btn) return;
      activate(indexOf(tabs, btn));
    });

    // Tastatur — ARIA Tabs-Pattern (Pfeile/Home/End, roving tabindex).
    tablist.addEventListener('keydown', function (e) {
      var next = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (activeIndex + 1) % tabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (activeIndex - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      if (next >= 0) { e.preventDefault(); activate(next, true); }
    });

    // Responsiver Umschalter Tabs <-> Akkordeon.
    var mq = window.matchMedia(DESKTOP_MQ);
    function applyMode() {
      if (mq.matches) {
        root.classList.add('t-tabs-on');
        for (var p = 0; p < panels.length; p++) {
          // Alle Panels offen halten; Sichtbarkeit steuert .is-active per CSS.
          panels[p].setAttribute('open', '');
          panels[p].setAttribute('role', 'tabpanel');
          panels[p].setAttribute('aria-labelledby', tabs[p].id);
        }
        activate(activeIndex);
      } else {
        root.classList.remove('t-tabs-on');
        for (var q = 0; q < panels.length; q++) {
          // Native Akkordeon-Semantik wiederherstellen.
          panels[q].classList.remove('is-active');
          panels[q].removeAttribute('role');
          panels[q].removeAttribute('aria-labelledby');
          // Default „alles zu" auf Mobile (Owner); nur ein per #anchor angesprungenes
          // Panel startet offen — sonst bleiben alle Sektions-Karten geschlossen.
          if (q === initialIndex && hashMatched) panels[q].setAttribute('open', '');
          else panels[q].removeAttribute('open');
        }
      }
    }
    if (mq.addEventListener) mq.addEventListener('change', applyMode);
    else if (mq.addListener) mq.addListener(applyMode); // ältere Safari
    applyMode();

    // In-Page-Anker zu einem Panel (z. B. Buy-Box-Sterne → #bewertungen) müssen das
    // Panel ÖFFNEN/AKTIVIEREN, nicht nur dorthin scrollen. Die Hash-Logik oben läuft
    // nur einmal beim Laden; ein Klick nach dem Laden landet sonst auf einem
    // zugeklappten Akkordeon (Mobile) bzw. inaktiven Tab (Desktop) → man sieht nichts.
    function focusPanel(id, smooth) {
      var idx = -1;
      for (var k = 0; k < panels.length; k++) { if (panels[k].id === id) { idx = k; break; } }
      if (idx < 0) return false;
      if (mq.matches) {
        activate(idx);
      } else {
        // Mobile: natives <details> öffnen → feuert `toggle` → Reviews laden lazy.
        panels[idx].setAttribute('open', '');
      }
      // Die Section-Nav (Desktop) bzw. den Akkordeon-Header (Mobile) ~40% in den
      // Viewport scrollen statt an die Oberkante: die Bewertung landet etwa mittig,
      // Tabs/Buy-Box bleiben darüber sichtbar, die erste Review darunter — sonst klebt
      // das Panel hinter dem Sticky-Header und wirkt „zu weit unten".
      // WICHTIG: synchron + instant. behavior:'smooth' UND ein scrollTo aus einem
      // requestAnimationFrame heraus werden auf dieser Seite verschluckt (Ziel landet
      // bei scrollY 0); ein synchroner window.scrollTo(0, y) scrollt zuverlässig und
      // bleibt stehen. getBoundingClientRect erzwingt den Reflow nach activate()/
      // <details>open, daher stimmt die Messung ohne rAF.
      var target = mq.matches ? tablist : panels[idx];
      if (target && target.getBoundingClientRect) {
        var pageY = window.pageYOffset || document.documentElement.scrollTop || 0;
        var dest = target.getBoundingClientRect().top + pageY - (window.innerHeight || 800) * 0.4;
        if (dest < 0) dest = 0;
        window.scrollTo(0, dest);
      }
      return true;
    }

    document.addEventListener('click', function (e) {
      var link = e.target && e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!link) return;
      // Nur Same-Page-Anker abfangen; Cross-Page-Links normal navigieren lassen.
      if (link.pathname && link.pathname !== window.location.pathname) return;
      var href = link.getAttribute('href') || '';
      var hi = href.indexOf('#');
      if (hi < 0) return;
      var id = href.slice(hi + 1);
      if (!id) return;
      if (focusPanel(id, true)) {
        e.preventDefault();
        if (window.history && history.replaceState) history.replaceState(null, '', '#' + id);
      }
    });

    window.addEventListener('hashchange', function () {
      if (window.location.hash) focusPanel(window.location.hash.slice(1), true);
    });
  }

  function buildTablist(panels) {
    var tablist = document.createElement('div');
    tablist.className = 't-pdp-tabs';
    tablist.setAttribute('role', 'tablist');
    tablist.setAttribute('aria-label', 'Produktinformationen');

    for (var i = 0; i < panels.length; i++) {
      var panel = panels[i];
      var titleEl = panel.querySelector('.t-acc__title');
      var title = titleEl ? titleEl.textContent : ('Abschnitt ' + (i + 1));

      var panelId = panel.id || ('t-panel-' + i);
      panel.id = panelId;

      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 't-pdp-tabs__tab';
      tab.id = panelId + '-tab';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panelId);
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');

      // Icon des Akkordeons spiegeln, falls vorhanden. WICHTIG: nur das Icon des
      // EIGENEN Top-Level-Summary (:scope >) — sonst würde z. B. „Rechtliche
      // Hinweise" fälschlich das Icon eines Unter-Akkordeons im Body abgreifen und
      // das Label (+ damit den roten Indikator) verschieben.
      var iconEl = panel.querySelector(':scope > .t-acc__summary > .t-acc__icon > .t-icon');
      if (iconEl) {
        var icon = iconEl.cloneNode(false);
        icon.className = iconEl.className + ' t-pdp-tabs__icon';
        tab.appendChild(icon);
      }
      var label = document.createElement('span');
      label.className = 't-pdp-tabs__label';
      label.textContent = title;
      tab.appendChild(label);

      tablist.appendChild(tab);
    }
    return tablist;
  }

  function indexOf(nodeList, node) {
    for (var i = 0; i < nodeList.length; i++) if (nodeList[i] === node) return i;
    return -1;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
